import React, { FC } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import GlobalStyles from "../../styles/GlobalStyles";

interface Props {
  cancelAction?: () => void;
  confirmAction?: () => void;
  logout?: () => void;
  onChange?: (open: boolean) => void;
  isOpen: boolean;
  content: string;
  title: string;
  tokenExpiration: boolean;
}

const ConfirmDialogComponent: FC<Props> = (p) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      whiteColor: {
        color: GlobalStyles.secondaryColor,
        margin: theme.spacing(0, 0, 0),
        background: GlobalStyles.fourthColor,
        "&:hover": {
          backgroundColor: GlobalStyles.secondaryColor,
          color: GlobalStyles.fourthColor,
        },
      },
      primaryBackground: {
        margin: theme.spacing(0, 1, 0),
        background: GlobalStyles.primaryColor,
        "&:hover": {
          backgroundColor: GlobalStyles.secondaryColor,
        },
      },
      outlined: {
        margin: theme.spacing(0, 1, 0, 0),
      },
      dialog: {
        minWidth: "400px !important",
      },
    })
  );

  const _renderStatusNewActions = (tokenExpiration: boolean) => {
    if (tokenExpiration) {
      return (
        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            onClick={p.logout}
            color="secondary"
            variant="contained"
            className={classes.primaryBackground}
          >
            Cerrar Sesión
          </Button>
        </DialogActions>
      )
    } else {
      return (
        <DialogActions>
          <Button
            onClick={p.cancelAction}
            color="primary"
            variant="outlined"
            className={classes.outlined}
          >
            Cancelar
          </Button>
          <Button
            onClick={p.confirmAction}
            color="secondary"
            variant="contained"
            autoFocus
            className={classes.primaryBackground}
          >
            Aceptar
          </Button>
        </DialogActions>
      )
    }
  };

  const classes = useStyles();
  return (
    <>
      <Dialog
        open={p.isOpen}
        onClose={p.onChange}
        classes={{ paper: classes.dialog }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{p.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {p.content}
          </DialogContentText>
        </DialogContent>
        {_renderStatusNewActions(p.tokenExpiration)}
      </Dialog>
    </>
  );
};

export default ConfirmDialogComponent;
